/**
 * @generated SignedSource<<4c1be36c921c2151757847616d0906aa>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type DiagnosticInferredSkillsQuery$variables = {
  studentId: string;
  userId: string;
};
export type DiagnosticInferredSkillsQuery$data = {
  readonly currentTargetGroupByStudentId: {
    readonly targetGroup: {
      readonly targets: ReadonlyArray<{
        readonly targetSkills: ReadonlyArray<{
          readonly isActive: boolean;
          readonly skill: {
            readonly id: string;
          } | null | undefined;
          readonly targetSkillType: {
            readonly name: string | null | undefined;
          } | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly studentsDemonstratedSkillsReport: ReadonlyArray<{
    readonly demonstratedSkills: number;
  }>;
};
export type DiagnosticInferredSkillsQuery = {
  response: DiagnosticInferredSkillsQuery$data;
  variables: DiagnosticInferredSkillsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "studentId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "userId"
  }
],
v1 = {
  "alias": null,
  "args": [
    {
      "fields": [
        {
          "items": [
            {
              "kind": "Variable",
              "name": "studentIds.0",
              "variableName": "userId"
            }
          ],
          "kind": "ListValue",
          "name": "studentIds"
        }
      ],
      "kind": "ObjectValue",
      "name": "filter"
    }
  ],
  "concreteType": "StudentDemonstratedSkillsReport",
  "kind": "LinkedField",
  "name": "studentsDemonstratedSkillsReport",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "demonstratedSkills",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v2 = [
  {
    "kind": "Variable",
    "name": "studentId",
    "variableName": "studentId"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isActive",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "SkillNode",
  "kind": "LinkedField",
  "name": "skill",
  "plural": false,
  "selections": [
    (v4/*: any*/)
  ],
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DiagnosticInferredSkillsQuery",
    "selections": [
      (v1/*: any*/),
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "StudentTargetGroupNode",
        "kind": "LinkedField",
        "name": "currentTargetGroupByStudentId",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TargetGroupNode",
            "kind": "LinkedField",
            "name": "targetGroup",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "TargetNode",
                "kind": "LinkedField",
                "name": "targets",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TargetSkillNode",
                    "kind": "LinkedField",
                    "name": "targetSkills",
                    "plural": true,
                    "selections": [
                      (v3/*: any*/),
                      (v5/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TargetSkillTypeNode",
                        "kind": "LinkedField",
                        "name": "targetSkillType",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DiagnosticInferredSkillsQuery",
    "selections": [
      (v1/*: any*/),
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "StudentTargetGroupNode",
        "kind": "LinkedField",
        "name": "currentTargetGroupByStudentId",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TargetGroupNode",
            "kind": "LinkedField",
            "name": "targetGroup",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "TargetNode",
                "kind": "LinkedField",
                "name": "targets",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TargetSkillNode",
                    "kind": "LinkedField",
                    "name": "targetSkills",
                    "plural": true,
                    "selections": [
                      (v3/*: any*/),
                      (v5/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TargetSkillTypeNode",
                        "kind": "LinkedField",
                        "name": "targetSkillType",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          (v4/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v4/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v4/*: any*/)
                ],
                "storageKey": null
              },
              (v4/*: any*/)
            ],
            "storageKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f97d4a4c7bf1506c3a4c16b7a240fefe",
    "id": null,
    "metadata": {},
    "name": "DiagnosticInferredSkillsQuery",
    "operationKind": "query",
    "text": "query DiagnosticInferredSkillsQuery(\n  $studentId: ID!\n  $userId: ID!\n) {\n  studentsDemonstratedSkillsReport(filter: {studentIds: [$userId]}) {\n    demonstratedSkills\n  }\n  currentTargetGroupByStudentId(studentId: $studentId) {\n    targetGroup {\n      targets {\n        targetSkills {\n          isActive\n          skill {\n            id\n          }\n          targetSkillType {\n            name\n            id\n          }\n          id\n        }\n        id\n      }\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "7c4f88e8330849bd8d7687841d309771";

export default node;
